import { render, staticRenderFns } from "./RsaPazienteProgettoPriPage.vue?vue&type=template&id=0484f0fa"
import script from "./RsaPazienteProgettoPriPage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteProgettoPriPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports